<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('groupInfo')">
			<el-row>
				<div id="salesmanList">
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="100">
      <FormItem class="form_item" :label="$t('conditionMemberId')">
        <Input  clearable size="default"  v-model="empCode" :placeholder="$t('enter')"/>
      </FormItem>
      <div class="buttonDiv">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchGroupUserList">{{$t('search')}}</el-button>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addGroupUser">{{$t('add')}}</el-button>
      </div>
    </Form>
     <div class="contentTableDiv">
         <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
           <!-- 此处的Id为groupUser表的Id，可通过此Id进行删除操作 -->
            <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
            <el-table-column prop="groupId" label="groupId" v-if="false" ></el-table-column>
              <!-- <el-table-column prop="userId" :label="$t('userId')" align="center" :show-overflow-tooltip="true"></el-table-column> -->
            <el-table-column prop="empCode" :label="$t('groupMemberID')" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="empName" :label="$t('name')" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="empEmail" :label="$t('userEmail')" align="center" :show-overflow-tooltip="true"></el-table-column>
             <el-table-column :label="$t('operate')" align="center" fixed="right"  width="400">
              <template slot-scope="scope">
                <!-- <el-button size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button> -->
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button>
                <!-- <el-button size="mini" type="success" @click="roleToMenu(scope.row)">{{$t('operateRole')}}</el-button> -->
             </template>
          </el-table-column>
        </el-table> 
    </div>
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
         layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!--新增-->
    <Modal v-model="modelAdd" :closable='false' :mask-closable='false' :title="$t('addGroupUserInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="add">{{$t('confrim')}}</Button>
      </div>
      <Form  ref="addGroupUserForm"  :label-width="150">
        	<Form-item :label="$t('groupUser')" prop="groupUser">
                    <el-select v-model="empCode1" clearable filterable remote :remote-method="remoteMethod">
                      <el-option v-for="(item, index) in GroupUserList" :key="index" :label="item.userCode" :value="item.userCode"></el-option>
                    </el-select>
					</Form-item>
      </Form> 
    </Modal>							 
   </div>		
	</el-row>
</el-tab-pane>
    
    
    <el-row>
      <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
        <!-- <el-button type="primary" @click="submitForm('projectForm')">{{$t('save')}}</el-button> -->
        <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
      </el-col>
    </el-row>
	</el-tabs>
</template>
<script>
    import * as validate from '@/utils/validate'

    export default {
        // name: 'role',
        created () {
           this.getGroupUserInfo();
           this.getParams();
          // this.getAllMenu();//获取所有菜单作为展开项
        },
        data () {
            return {
              id:null,
              groupId:this.$route.params.groupId,
              currentPage: 1,
              empCode:"",
              empCode1:"",
              totalCount: 0,
              pageSize: 10,
              tableData: [],
              rangeNumber: 10,
              GroupUserList:[],
              addGroupUserForm:{
              groupUserName:null,
              },
              modelAdd: false,       
              treeExpandedKeys:[],//展开项
 
            }
        },
        methods: {
           getParams(){
            this.gourpId = this.$route.params.groupId;
           },
           getGroupUserInfo(){
              let url = `${this.$store.state.islhurl}getGroupUserByGroupId/${this.pageSize}/${this.currentPage}`
              let pm = {
                groupId: this.$route.params.groupId,
                empCode:'',

              }
              //查询时返回的Id为group_user的Id
              this._post(url,pm).then(
                res =>{
                  this.tableData =res.data;
                  this.totalCount = res.totalNums;
                }
              )
            },
           
            searchGroupUserList(){
              this.pageSize = 10;
              this.currentPage = 1;
              let url = `${this.$store.state.islhurl}getGroupUserByGroupId/${this.pageSize}/${this.currentPage}`
              let pm = {
                groupId: this.groupId,
                empCode: this.empCode,
              }
              this._post(url,pm).then(
                res =>{
                  this.tableData =res.data
                  this.totalCount = res.totalNums
                }
              )
            },
            loadMore(n) {
              // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
              // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方
              return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
            },
            //远程搜索方法
            remoteMethod(query) {
              if (query !== '') {
                // 清除之前的定时器
                if (this.timeout) {
                  clearTimeout(this.timeout)
                }
                // 防抖处理，300ms后执行
                this.timeout = setTimeout(() => {
                  this.fetchUserOptions(query)
                }, 200)
              } else {
                this.GroupUserList = [];
              }
            },
            fetchUserOptions(query) {
              let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
              this._get(url).then().then(res => {
                if(res.code === 200 && res.data) {
                  this.GroupUserList = res.data;
                } else {
                  this.GroupUserList = [];
                }
              }).catch(error => {
                this.GroupUserList = [];
                console.error('搜索失败:', error)
              })
            },
            getAllMenu(){
              let url = `${this.$store.state.islhurl}getAllMenu`             
              this._get(url).then(
                res => {      
                  this.treeExpandedKeys = res;
                  // console.log(res);
                }
              )
            },
            addGroupUser(){
              this.addGroupUserForm.groupUserName = null;
              this.modelAdd = true
            },
            add(){
              if(this.empCode1 === null || this.empCode1=== ''){
                var msg = this.$t('userNameNull');
                this.$Message.error(msg);
                return;
              }

              let params = {
                groupId:this.groupId,
                empCode:this.empCode1,
              }
              let url = `${this.$store.state.islhurl}addGroupUser`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.modelAdd = false;
                  this.getGroupUserInfo();
                  var msg = this.$t('saveSus');
                  this.$Message.success(msg);
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )

            },
            // handleEdit(index) {
            //   this.roleId = index.roleId
            //   this.updateRoleForm.roleName = index.name
            //   this.updateRoleForm.description = index.description
            //   this.modelUpdate = true;
            // },
            //修改Role信息确认
            // ok(){
            //   if(this.updateRoleForm.roleName === null || this.updateRoleForm.roleName === ''){
            //     var msg = this.$t('roleNameNull');
            //     this.$Message.error(msg);
            //     return
            //   }
            //   if(this.updateRoleForm.description === null || this.updateRoleForm.description ===''){
            //     var msg = this.$t('roleDesNull');
            //     this.$Message.error(msg);
            //     return
            //   }
            //   let params = {
            //     roleId: this.roleId,
            //     name : this.updateRoleForm.roleName,
            //     description: this.updateRoleForm.description,
            //   }
            //   let url = `${this.$store.state.islhurl}updateRole`
            //   this._post(url,params).then(
            //     res => {
            //       this.modelUpdate = false;
            //       this.getRoleList();
            //       var msg = this.$t('modifySus');
            //       this.$Message.success(msg);
            //     }
            //   )   
            // },
           
            handleDelete(index){
              var msg1 = this.$t('delMsg');
              var msg2 = this.$t('warnMsg');
              var msg3 = this.$t('confrim');
              var msg4 = this.$t('cancle');
              this.$confirm(msg1, msg2, {
                confirmButtonText: msg3,
                cancelButtonText: msg4,
                type: 'warning'
              }).then(() => {
                //  console.log(index.id);
                let url = `${this.$store.state.islhurl}delGroupUser`

                let pm={
                  id:index.id            
                }
                this._post(url,pm).then(
                  res =>{
                    var msg = this.$t('delSus');
                    this.$Message.success(msg);
                    // this.getGroupUserId();
                    this.getGroupUserInfo();
                  }
                )
              }).catch(() => {
              }); 
            },

            cancel(){
              this.modelAdd = false;
              this.modelUpdate = false;
            },
            // 分页
            changePage (val) {
              this.currentPage = val
              this.getGroupUserInfo();
            },
            // 改变当前页显示条数
            changePageSize (val) {
              this.pageSize = val
              this.getGroupUserInfo();
            },
            returnList(){
            this.$router.push({path:'/group/list'})
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/group/groupEdit.vue